module.exports = __webpack_public_path__ + "img/Markforged-Mark-Two.8f46876d.png";